/* OMG: hide redundant "(Bundle Component)" chips in the cart drawer.
   The child-injector adds real $0 component lines; the Svelte drawer renders
   them as chips ALONGSIDE the parent's "Flavor N" chips -> looks like doubles.
   We keep the customer-facing Flavor chips and hide the component chips.
   Guards: only small "block"-class pills with short text are hidden, never cards. */
(function () {
  if (window.__omgBundleChipHide) return;
  window.__omgBundleChipHide = true;
  function sweep() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('div.block.border.rounded-lg').forEach(function (pill) {
      var txt = (pill.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^\d+\s*[x×]\s+.+\s+\(bundle component\)$/i.test(txt)) {
        pill.hidden = true;
        pill.setAttribute('aria-hidden', 'true');
        pill.style.setProperty('display', 'none', 'important');
      }
    });
  }
  function init() {
    var d = document.getElementById('cart-drawer');
    if (!d) return void setTimeout(init, 500);
    new MutationObserver(sweep).observe(d, { childList: true, subtree: true });
    sweep();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* OMG: orphan-children cart guard.
   If a shopper deletes the bundle PARENT line in the drawer, the hidden $0
   component children would linger and ship as free product. On every cart
   mutation (debounced), reconcile: any _bundle group with children but no
   _bundle_main parent -> remove those children via /cart/update.js. */
(function () {
  if (window.__omgBundleCartGuard) return;
  window.__omgBundleCartGuard = true;
  var busy = false;
  var timer = null;
  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parents = {};
        var children = {};
        (cart.items || []).forEach(function (i) {
          var p = i.properties || {};
          if (!p._bundle) return;
          if (p._bundle_main === 'true' || p._bundle_main === true) {
            parents[p._bundle] = true;
          } else {
            (children[p._bundle] = children[p._bundle] || []).push(i.key);
          }
        });
        var updates = {};
        Object.keys(children).forEach(function (bid) {
          if (!parents[bid]) {
            children[bid].forEach(function (k) { updates[k] = 0; });
          }
        });
        if (!Object.keys(updates).length) { busy = false; return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 900);
  }
  function init() {
    var d = document.getElementById('cart-drawer');
    if (!d) return void setTimeout(init, 500);
    new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* OMG: header cart badge correction.
   The badge shows raw cart.item_count, which includes the hidden $0 component
   lines (a 4-pack reads as "5"). Show item_count MINUS component quantities so
   a bundle counts as 1 (the parent), matching what the shopper thinks they added. */
(function () {
  if (window.__omgBundleBadgeFix) return;
  window.__omgBundleBadgeFix = true;
  var lastApplied = null;
  function badgeEl() {
    var link = Array.prototype.find.call(
      document.querySelectorAll('a[href*="cart"]'),
      function (a) { return a.querySelector('svg text'); }
    );
    return link ? link.querySelector('svg text') : null;
  }
  function fix() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hidden = 0;
        (cart.items || []).forEach(function (i) {
          var p = i.properties || {};
          if (p._bundle && !(p._bundle_main === 'true' || p._bundle_main === true)) {
            hidden += i.quantity;
          }
        });
        var corrected = Math.max(0, (cart.item_count || 0) - hidden);
        var el = badgeEl();
        if (el && el.textContent !== String(corrected)) {
          el.textContent = String(corrected);
          lastApplied = corrected;
        }
      })
      .catch(function () {});
  }
  var t2 = null;
  function schedule2() { clearTimeout(t2); t2 = setTimeout(fix, 700); }
  function init2() {
    var d = document.getElementById('cart-drawer');
    if (d) new MutationObserver(schedule2).observe(d, { childList: true, subtree: true });
    var hdr = document.querySelector('header') || document.body;
    new MutationObserver(function (muts) {
      // re-assert if the app rewrites the badge back to raw count
      var el = badgeEl();
      if (el && lastApplied !== null && el.textContent !== String(lastApplied)) schedule2();
    }).observe(hdr, { childList: true, subtree: true, characterData: true });
    fix();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init2);
  } else {
    init2();
  }
})();
